import { PaginatedReviewResponse } from '@/types/api'
import { ReviewItem, ReviewResponse } from '@/types/collection'

const SIZES = [
  'XS',
  'S',
  'M',
  'L',
  'XL',
  'XXL',
  '2XL',
  '3XL',
  '4XL',
  '28',
  '29',
  '30',
  '31',
  '32',
  '33',
  '34',
  '36',
  '38',
  '40',
  '42',
].map((s) => s.toUpperCase())

const parseVariant = (variant: string) => {
  if (!variant) {
    return { color: null, size: null }
  }

  const parts = variant.split(/[\s/]+/).filter(Boolean) // Tách bằng khoảng trắng hoặc dấu /
  let size = null
  let color = variant.trim()

  // Tìm size từ cuối chuỗi
  for (let i = parts.length - 1; i >= 0; i--) {
    const potentialSize = parts[i].toUpperCase()
    if (SIZES.includes(potentialSize)) {
      size = parts[i]
      const sizeIndex = variant.toUpperCase().lastIndexOf(potentialSize)
      color = variant.substring(0, sizeIndex).trim()

      // Loại bỏ các ký tự phân cách thừa ở cuối màu
      if (color.endsWith('/') || color.endsWith('-')) {
        color = color.slice(0, -1).trim()
      }
      break
    }
  }

  return { color, size }
}

export const reviewFormatter = {
  formatReview: (data: ReviewResponse) => {
    const { list, ...rest } = data

    return {
      ...rest,
      list: list?.map((item: ReviewItem) => {
        const parsedVariants = item.bought_variants?.map(parseVariant) || []
        return {
          ...item,
          color: parsedVariants[0]?.color,
          size: parsedVariants[0]?.size,
        }
      }),
    }
  },
  formatReviewPaginated: (data: PaginatedReviewResponse<ReviewResponse>) => {
    if (!data.data) {
      return data
    }

    const formattedList = data?.data?.list?.map((item: ReviewItem) => {
      const parsedVariants = item.bought_variants?.map(parseVariant) || []
      return {
        ...item,
        color: parsedVariants[0]?.color,
        size: parsedVariants[0]?.size,
      }
    })

    return {
      ...data,
      data: {
        ...data.data,
        list: formattedList,
      },
    }
  },
}
